import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { WorkflowTemplateRepository } from "../domain/WorkflowTemplateRepository";
import { nameToClass, UploadAsInvoice, WaitForApproval, WorkflowTemplate, AskAI, AddDocumentRepresentationToConversation,LookupAndMatchInstance, LookupAndMatchMultipleInstances,SendThroughEmail, SendEmailWithTemplate,RunCommand,RunQuery, SendDataToEndpoint, NotifyCounterpart, ExtractInstanceFromRawData, CreateInstanceFromContext,CompleteConversation,AddInstanceToList,CreateInstance,CreateInstancesFromList,ModifyContext,RunScript } from "../domain/WorkflowTemplate";

function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }

    return dict;
}


export class ApiWorkflowTemplateRepository implements WorkflowTemplateRepository{
    
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: QueryDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
    }

    api_to_domain(wf) {
        let id = wf.id
        let name = wf.name
        let stages = wf.stages.map(stage => {
            console.log(stage)
            let my_class = nameToClass[stage.name]
            if( stage.name == 'AskAI' ){
                stage['save_as_key'] = stage['key']
            }
            const instance = Object.assign(new my_class, stage);
            console.log(instance);
            return instance
        }
        )
        let doc_types = wf.default_doc_types
        let trigger_entity_type_uuid = wf.trigger_entity_type_uuid
        return new WorkflowTemplate(id, stages, name, doc_types, trigger_entity_type_uuid)
    }

    domain_to_api(wf: WorkflowTemplate) {
        return JSON.parse(JSON.stringify(objectToDict(wf)));
    }

    async find_by_id(wf_id: number): Promise<WorkflowTemplate> {
        try {
            let res = await this.query_dispatcher.dispatch('workflow.template.query', { wf_id: wf_id })
            if (res) {
                return this.api_to_domain(res)
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async get_workflow_template(): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('workflow.templates.query', {})
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async save_workflow_template(wf: WorkflowTemplate): Promise<any> {
        let wf_data = this.domain_to_api(wf)
        try {
            let res = await this.sync_command_dispatcher.dispatch('save.workflow.template', {wf: wf_data});
            if (res) {
                return res.output
            }
                return null
        } catch (error) {
            return null
        }
    }

    async filter_by_company_id(company_id: Number,ordering, limit, offset): Promise<Object> {
        let query_args = {}//{ company_id: company_id}
        let args = {args: query_args}
        if (ordering) {
            args['ordering'] = ordering
        }
        if (limit) {
            args['limit'] = limit
        }
        if (offset) {
            args['offset'] = offset
        }
        let inv_data = await this.query_dispatcher.dispatch('workflow.templates.query', args)
        let count = inv_data.count
        inv_data = inv_data.results || []
        let inv_list = []
        for (let inv in inv_data) {
            inv_list.push(this.api_to_domain(inv_data[inv]))
        }
        if(!count){
            count = inv_list.length
        }
        return {results:inv_list, count: count}
    }
    
    async get_available_users(): Promise<any[]> {
        try {
            let query_args = {}//{ company_id: company_id}
            let args = {args: query_args}
            args['ordering'] = '-id' //si no hi ha args fa POST i em lia els tipus de return
            args['limit'] = 1000
            let res = await this.query_dispatcher.dispatch('available.users.query', args)
            return res.results
        } catch (error) {
            console.error(error)
            return
        }
    }

    // async get_all_schemas(exclude_template_id=null): Promise<any> {
    //     let args = {exclude_template_id: exclude_template_id}
    //     let res = await this.query_dispatcher.dispatch('all.schemas', args)
    //     return res
    // }
}

export class MemoryWorkflowTemplateRepository implements WorkflowTemplateRepository{
    wf_templates: WorkflowTemplate[] = []

    constructor(wfs: WorkflowTemplate[]) {
        this.wf_templates = wfs
    }
    async find_by_id(wf_id: number): Promise<WorkflowTemplate> {
        let wf = this.wf_templates.find(wf => wf.id === wf_id)
        return wf
    }

    async get_workflow_template(): Promise<any> {
        return this.wf_templates
    }

    async save_workflow_template(wf: WorkflowTemplate): Promise<any> {
        this.wf_templates.push(wf)
        return wf
    }

    async filter_by_company_id(company_id: Number,ordering, limit, offset): Promise<Object> {
        let wf_templates = this.wf_templates
        let count = wf_templates.length
        return {results:wf_templates, count: count}
    }

    async get_available_users(): Promise<any[]> {
        return []
    }

    async get_all_schemas(exclude_template_id=null): Promise<any> {
        return []
    }

}